<template>
  <div class="rate-table">
    <b-button @click="() => (filters.archived = !filters.archived)">
      {{ filters.archived ? "Show Active" : "Show Archived" }}
    </b-button>
    <b-button
      type="is-success"
      :loading="archiving"
      :disabled="!ratesChecked.length || archiving"
      @click="() => archiveRestoreRates('restore')"
      v-if="filters.archived"
    >
      RESTORE
    </b-button>
    <b-button
      type="is-warning"
      :loading="archiving"
      :disabled="!ratesChecked.length || archiving"
      @click="() => archiveRestoreRates('archive')"
      v-else
    >
      ARCHIVE
    </b-button>
    <b-button class="is-pulled-right" @click="importRates">Import</b-button>

    <base-table
      :service="$options.orderOperationClaimServiceService"
      fetch-func="all"
      :fetch-params="tableFetchParams"
      :columns="columns"
      checkable
      :checked.sync="ratesChecked"
      ref="baseTable"
    >
      <template #rowStatus="{ row }">
        {{ row.status ? "ACTIVE" : "ARCHIVED" }}
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from "@/components/partials/BaseTable";
import { CodeService } from "@/services/code.service";
import { OrderOperationClaimServiceService } from "@/services/orderOperationClaimService.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import FlatfileImporter from "flatfile-csv-importer";
import config from "@/config";

export default {
  orderOperationClaimServiceService: OrderOperationClaimServiceService,
  props: {
    firmId: {
      type: [String, Number]
    },
    contractId: {
      type: [String, Number]
    }
  },
  components: {
    BaseTable
  },
  data: () => ({
    filters: {
      archived: false
    },
    columns: [
      {
        field: "category",
        label: "Category"
      },
      {
        field: "ninaCode",
        label: "Nina Code"
      },
      {
        field: "description",
        label: "Description"
      },
      {
        field: "displayOrder",
        label: "Display Order"
      },
      {
        field: "status",
        label: "",
        meta: {
          rowSlot: "rowStatus"
        }
      }
    ],
    ratesChecked: [],
    importer: null,
    archiving: false
  }),
  computed: {
    user() {
      return this.$store.state.Auth.user;
    },
    tableFetchParams() {
      return {
        contract_id: this.contractId || undefined,
        firm_id: this.firmId || undefined,
        status: this.filters.archived ? 0 : 1
      };
    }
  },
  mounted() {
    this.fetchRates();
    // Initialize FlatFileImporter
    FlatfileImporter.setVersion(2);
    this.importer = new FlatfileImporter(
      config.flatfileLicense,
      config.rateFlatfileOptions
    );
    this.importer.setCustomer({
      userId: this.user.id,
      name: this.user.fullName,
      email: this.user.email
    });
  },
  watch: {
    "filters.archived"() {
      this.$nextTick(() => {
        this.fetchRates();
      });
    }
  },
  methods: {
    async fetchRates() {
      await this.$refs.baseTable.fetchData();
    },
    async archiveRestoreRates(mode = "archive") {
      try {
        this.archiving = true;
        const ids = this.ratesChecked.map(v => v.id);
        if (mode === "archive") {
          await OrderOperationClaimServiceService.bulkArchive({ ids });
        } else {
          await OrderOperationClaimServiceService.bulkRestore({ ids });
        }
        this.$buefy.toast.open({
          message: `Rates has been ${mode}d.`,
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.ratesChecked = [];
        this.fetchRates();
        this.archiving = false;
      }
    },
    // Cloned/Modified organizationRates->importData()
    async importRates() {
      let data = await OrderOperationClaimServiceService.all({
        ...this.tableFetchParams,
        status: undefined
      }).then(response => JsonDenormalizer.denormalize(response));
      data = data.map(v => v.ninaCode);

      let localRecord = [];
      this.importer.registerRecordHook((record, index) => {
        index = index - 1;
        if (typeof localRecord[index] === "undefined") {
          localRecord.push(record);
        } else {
          localRecord[index].nina_code = record.nina_code;
        }
        let error = {};
        if (data.includes(record.nina_code)) {
          error.nina_code = {
            info: [
              {
                message:
                  "Duplicate: This rate code has been imported previously.",
                level: "error"
              }
            ]
          };
        } else {
          let nina_code = localRecord.map(element => element.nina_code);
          let count = nina_code.filter(element => element == record.nina_code)
            .length;
          if (count > 1) {
            error.nina_code = {
              info: [
                {
                  message:
                    "Duplicate: Import file contains multiple records of this rate code.",
                  level: "error"
                }
              ]
            };
          }
        }
        return error;
      });

      await this.importer.requestDataFromUser().then(async response => {
        await OrderOperationClaimServiceService.import({
          firm_id: this.firmId || undefined,
          contract_id: this.contractId || undefined,
          data: response.data
        })
          .then(() => {
            this.importer.close();
            this.$buefy.toast.open({
              message: "Rates successfully imported.",
              type: "is-success",
              position: "is-top-right"
            });
            this.fetchRates();
          })
          .catch(error => {
            this.importer.displayError(error.message);
          });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Rate/RateTable.vue